import { Button } from 'components/Button/Button';
import { ContactsModal } from 'components/ContactsModal/ContactsModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const AddNewContact = ({ types, member, company }: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation('translation', { keyPrefix: 'contacts' });
    return (
        <>
            <Button onClick={() => setIsOpen(true)}>{t('addNewContact')}</Button>
            <ContactsModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                types={types}
                member={member}
                company={company}
            />
        </>
    );
};
